import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import type { RichTranslationValues } from 'next-intl';
import type { ReactNode } from 'react';

import { LEGAL_FOOTNOTES_ID } from '@/app/consts/ids';

const getValues = (): RichTranslationValues => {
  return {
    footnoteLink: function footnoteLink(chunks: ReactNode) {
      return (
        <sup>
          <a href={`#${LEGAL_FOOTNOTES_ID}`}>{chunks}</a>
        </sup>
      );
    },
    myAccountLink: function myAccountLink(chunks: ReactNode) {
      return (
        <BodyLink color="inherit" href="/my-account">
          {chunks}
        </BodyLink>
      );
    },
    privacyPolicyLink: function privacyPolicyLink(chunks: ReactNode) {
      return (
        <BodyLink color="inherit" href="/privacy-policy">
          {chunks}
        </BodyLink>
      );
    },
    ouraOnTheWebLink: function ouraOnTheWebLink(chunks: ReactNode) {
      return (
        <BodyLink
          color="inherit"
          href="https://cloud.ouraring.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {chunks}
        </BodyLink>
      );
    },
  };
};

export default getValues;
